<template>
  <div>
    <page-title title="Allergens" />
    <b-row>
      <b-col>
        <filtered-table :settings="tableSettings">
        </filtered-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "AllergenList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        query: 'allergens',
        newUrl: '/allergen/add',
        columns: [
          {
            key: 'id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'name',
            name: 'Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'family',
            name: 'Family Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'commonName',
            name: 'Common Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'type',
            name: 'Type',
            visible: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'POLLEN', text: 'Pollen' },
              { value: 'SPORE', text: 'Spore' },
            ]
          },
          {
            key: 'category',
            name: 'Category',
            visible: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'TREE', text: 'Tree' },
              { value: 'WEED', text: 'Weed' },
              { value: 'GRASS', text: 'Grass' },
              { value: 'MOLD', text: 'Mold' },
              { value: 'UNIDENTIFIED', text: 'Unidentified' }
            ]
          }
        ],
        rowClicked: function (item, context) {
          context.$router.push('/allergen/' + item.id)
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  }
};
</script>